import BusComponent from "../BusComponent";
import { injectIntl } from "react-intl";
import React from "react";
import classNames from "classnames";
import FileUploadError from "../uploadFile/FileUploadError";
import FileDropArea from "../uploadFile/FileDropArea";
import FileInput from "../form/FileInput";
import MyUploads from "../userDataUploadEditor/MyUploads";
import AppConfig from '../../appConfig';

const MAX_FILE_UPLOAD_SIZE_IN_MB = 100;

class UploadPointDataPanel extends BusComponent {
    constructor(props, context) {
        super(props, context);
    }

    static componentName() {
        return 'DATA_UPLOAD_OPTIONS';
    }

    onDataUploaded = file => {
        const { intl } = this.props;

        if (file.size > MAX_FILE_UPLOAD_SIZE_IN_MB * 1024 * 1024) {
            this.emit('USER_DATA_ERROR', {
                type: 'UPLOAD_FILE_ERROR',
                userMessage: `${intl.formatMessage({ id: 'dataBrowser.csvFileTooLarge' })} ${MAX_FILE_UPLOAD_SIZE_IN_MB}MB.`
            });
            return;
        }
        this.emit('PARSE_USER_DATA_UPLOAD', { file });
    }

    onFileSelected = files => {
        if (files && files.length) {
            this.onDataUploaded(files[0]);
        }
    }

    render() {
        const { error, onClose, onClearError, mapInstanceId, intl } = this.props;

        return (
            <div className='upload-point-data-panel'>
                <div className="upload-point-data-panel__header">
                    <span>
                        {intl.formatMessage({ id: 'dataBrowser.uploadPointData' })}
                    </span>
                    <button onClick={onClose}>
                        <i className="material-icons"> close </i>
                    </button>
                </div>
                { error && <FileUploadError error={error} onErrorOKClick={onClearError} /> }
                <div className="upload-point-data-panel__data-upload-options">
                    <div className="upload-point-data-panel__data-upload-options__description">
                        {intl.formatMessage({ id: 'hints.uploadAndGeocodeYourPOIs' })}
                    </div>
                    <div className="upload-point-data-panel__data-upload-options__upload_box">
                        <FileDropArea
                            graphics={`${AppConfig.constants.assetsBaseURL}/svg/upload-data.svg`}
                            onChange={this.onDataUploaded}
                            accept="text/csv,.csv"
                            errors={undefined}
                        >
                            <div className="flex-it center justify-center flex-column" style={{gap: '16px'}}>
                                <div className="upload-point-data-panel__data-upload-options__upload_box__description">
                                    {intl.formatMessage({ id: 'dataBrowser.dropYourCSVFileHereOr' })}
                                </div>
                                <FileInput
                                    accept="text/csv,.csv"
                                    onChange={this.onFileSelected}
                                    label={intl.formatMessage({ id: 'browse' })}
                                    className="upload-point-data-panel__browse-btn"
                                />
                            </div>
                        </FileDropArea>
                    </div>
                </div>
                <MyUploads mapInstanceId={mapInstanceId} />
        </div>);
    }
}

export default injectIntl(UploadPointDataPanel);
